export default { sha: '8daf3d92d3ea65fc3ae6e61945580827f6770de6', buildNumber: 'undefined' }
